import { DeleteOutline } from "@mui/icons-material";
import { Button, Grid, Paper, Box, CardActions, Pagination } from "@mui/material";
import React from "react";
import { LessonStudents } from "../../Api/OnlineLesson";
import { LessonStudent, LessonTeacher } from "../../Objects/OnlineLesson";
import CategoryTitle from "../atoms/CategoryTitle";
import CustomerCard from "../molecules/CustomerCard";

export interface LessonStudentListProps {
    lessonStudents: LessonStudents
    requestRegStudent: () => void
    requestUnregStudent: (lessonStudent: LessonStudent) => void
    onClick: (lessonStudent: LessonTeacher) => void
    onPageChange: (page: number) => void
}

const LessonStudentList: React.FC<LessonStudentListProps> = ({
    lessonStudents,
    requestRegStudent,
    requestUnregStudent,
    onClick,
    onPageChange
}) => {
    return (
        <Paper>
            <CategoryTitle text="オンラインレッスン生徒一覧" />
            <Box sx={{
                display: "flex",
                justifyContent: "right",
                margin: "14px"
            }}>
                <Button
                    onClick={() => {
                        requestRegStudent()
                    }}
                >生徒を登録する</Button>
            </Box>
            <Grid container sx={{ padding: "0 14px 14px 14px", marginTop: "14px" }} spacing={2}>
                {lessonStudents.list.map(lessonStudent => (
                    <Grid item key={lessonStudent.student_id} xs={12} sm={6} md={4}>
                        {lessonStudent.customerData &&
                            <CustomerCard
                                customer={lessonStudent.customerData}
                                footMenu={
                                    <CardActions sx={{
                                        display: "flex",
                                        justifyContent: "right"
                                    }}>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            startIcon={<DeleteOutline />}
                                            onClick={() => {
                                                requestUnregStudent(lessonStudent)
                                            }}
                                        >登録解除</Button>
                                    </CardActions>
                                }
                            />
                        }
                    </Grid>
                ))}
            </Grid>
            <Box sx={{
                padding: "10px",
                display: "flex",
                justifyContent: "center",
            }}>
                <Pagination count={lessonStudents.pagenum} onChange={(e, page) => {
                    onPageChange(page)
                }} variant="outlined" />
            </Box>
        </Paper>
    )
}

export default LessonStudentList